export interface DecimalFormatOptions {
  showThousandsSeperator?: boolean;
  minimumIntegerDigits?: number;
  numberDecimals?: number;
}

/**
 * Formats the value as a Decimal. Can be customized. Defaults to 1,234,567
 */
export function formatDecimal(
  value: number | string,
  {
    showThousandsSeperator = true,
    minimumIntegerDigits = 1,
    numberDecimals = 0,
  }: DecimalFormatOptions = {},
): string {
  // Null or Undefined Value
  if ((value === null) || (value === undefined)) {
    return '';
  }

  const numberValue = Number(value);

  // Format the Number as a String using the Options
  const stringValue = numberValue.toLocaleString('en', {
    style: 'decimal',
    useGrouping: showThousandsSeperator,
    minimumIntegerDigits,
    minimumFractionDigits: numberDecimals,
    maximumFractionDigits: numberDecimals,
  });

  return stringValue;
}
